<template>
    <v-list-tile>
            <AutocompleteDepartment 
                class="ml-4"      
                style="width: 90%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"          
                :prepend="'dns'" 
                v-on:return-selection="changeHandler" />
    </v-list-tile>
</template>

<script>
    import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
    import AutocompleteDepartment from '@/components/forms/AutocompleteDepartment.vue'

    export default {

        components: { AutocompleteDepartment },

        methods: {
            ...mapActions([     'fetchDept']),

            ...mapMutations([   'updateSearchResultSidebar',
                                'updateMainSidebar',
                                'setSearchResults',
                                'setSearchTitle',
                                'setSearchSubtitle',
                                'setSearchSort',
                                'setSelectedRoom',
                                'setLoading',
                                'unSetLoading',
                                'setSnackText',
                                'clearSearch',
                                'setSearchExportText'
                            ]),

            changeHandler (value) { 
                if (value) {                
                    this.submitSearch(value.deptID)
                }
            },
            
            submitSearch(value) {
                this.clearSearch()
                this.setLoading("dept")                
                this.fetchDept(value).then((data) => {

                    if (data == "No Rows Found") {
                        console.log("No Rows Found on Dept Search")
                        this.setSnackText("No Data Found")
                        this.unSetLoading("dept")
                        return
                    }

                    const subtitle =    `<div style="background-color: #383838;color: white;padding: 25px;margin-left: -25px;margin-top: -25px;">
                                                    <div class="headline">${data.deptName}</div>
                                                    <div style="margin-bottom: 10px;">${data.deptID}</div>
                                                    <div>Total Area: ${data.areaSum.toLocaleString()} ${data.borrowedAreaSum > 0 ? '(includes ' + data.borrowedAreaSum.toLocaleString() + ' borrowed)' : '' }</div>
                                                    <div>Bldg Count: ${data.bldgCount}</div>
                                                    <div>Room Count: ${data.roomCount}</div>
                                            `
                    this.setSearchResults(data)
                    this.setSearchTitle("Department Search")
                    this.setSearchExportText(data.deptName + " - " + data.deptID)
                    this.setSearchSubtitle(subtitle)
                    this.setSearchSort("bldgAlpha")
                    this.updateMainSidebar(false)          
                    this.updateSearchResultSidebar(true)
                    this.unSetLoading("dept")

                })
            },
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/search/SearchDept.vue